(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.announcement-bar-section');
      if (!this.section) return;

      this.isAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.sectionBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.setAnnouncementHeights();
      this.onResizeHandler = this.setAnnouncementHeights.bind(this);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onResizeHandler);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.isAlwaysSticky) {
        this.section.classList.add('shopify-section-announcement-sticky');
        this.setAnnouncementHeights();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onResizeHandler) window.removeEventListener('resize', this.onResizeHandler);
      this.setAnnouncementHeights();
    }

    setAnnouncementHeights() {
      const allStickySections = document.querySelectorAll(
        '.announcement-bar-section.shopify-section-announcement-sticky'
      );
      const visibleStickySections = document.querySelectorAll(
        '.announcement-bar-section.shopify-section-announcement-sticky:not(.shopify-section-announcement-hidden)'
      );
      let offset = 0;

      allStickySections.forEach((section) => {
        section.style.setProperty('--announcement-bar-height', `${section.offsetHeight}px`);
      });

      visibleStickySections.forEach((section) => {
        section.style.top = `${offset}px`;
        offset += section.offsetHeight;
      });

      document.documentElement.style.setProperty('--sticky-announcement-bar-height', `${offset}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        this.sectionBounds = entries[0].intersectionRect;
        observerInstance.disconnect();
      });

      observer.observe(this.section);
    }

    onScroll() {
      if (this.isAlwaysSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.sectionBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.sectionBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.sectionBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAlwaysSticky) return;
      this.section.classList.add('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky');
      this.section.style.top = '';
      this.setAnnouncementHeights();
    }

    reveal() {
      if (this.isAlwaysSticky) return;
      this.section.classList.add('shopify-section-announcement-sticky', 'animate');
      this.section.classList.remove('shopify-section-announcement-hidden');
      this.setAnnouncementHeights();
    }

    reset() {
      if (this.isAlwaysSticky) return;
      this.section.classList.remove(
        'shopify-section-announcement-hidden',
        'shopify-section-announcement-sticky',
        'animate'
      );
      this.section.style.top = '';
      this.setAnnouncementHeights();
    }
  }

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
